import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectBorderOptions } from '../../../_redux-borders';
import { VariantOption } from '../../../VariantOption';
import { VariantRadioGroup } from '../../variant-radio-group/VariantRadioGroup';
import { ChangeVariantWindowStep } from '../ChangeVariantWindowStep';
import styles from '../ChangeVariantWindow.module.scss';

const _ChangeBorderStep = ({ imageUrl, options, onChange, borderId, stepper }: Props) => {
    const isMobile = useMobile();
    return (
        <ChangeVariantWindowStep imageUrl={imageUrl} className={styles.container} stepper={stepper}>
            <VariantRadioGroup selected={borderId} onChange={onChange} options={options} />
        </ChangeVariantWindowStep>
    );
};

type OwnProps = {
    stepper?: () => JSX.Element;
    imageUrl?: string;
    sizeId: string | undefined;
    paperId: string | undefined;
    borderId: string | undefined;
    onChange: (borderId: string) => void;
};

type Props = OwnProps & {
    options: VariantOption[];
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    options: selectAvailableOptions(state, ownProps.sizeId, ownProps.paperId)
});

export const ChangeBorderStep = connect(
    mapStateToProps
)(_ChangeBorderStep);

const selectAvailableOptions = createSelector([
    selectBorderOptions
], borders => borders.filter(b => b.available));